export default __webpack_public_path__ + "static/media/logsba.79ca9c0c.png";